import React from "react";
import variables from "../styles/base/_universal.scss";
import styled from "styled-components";
import { RoundedButton } from "./Buttons";

const PrimaryButton = ({
  title,
  icon,
  handleClick,
  disabled,
  minWidth,
  marginLeft,
  showIcon,
  height,
  isgenai
}) => {
  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className="btn btnOutline"
      style={{ minWidth: minWidth, marginLeft: marginLeft, height: height,textTransform: isgenai ? 'none' : 'inherit'  }}

    >
      {showIcon ? (
        <>
          <img src={icon} alt="" style={{marginRight:isgenai? "2px" :"0"}} /> {title}
        </>
      ) : (
        title
      )}
    </button>
  );
};

export default PrimaryButton;
